import React from "react";
import Image from "next/image";

const AboutBannerDesktop = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    let yOffset = 0;
    if (window.innerWidth <= 768) {
      // Mobile version
      yOffset = -100;
    } else {
      // Desktop version
      yOffset = -150;
    }

    if (section) {
      const yPosition =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
    }
  };
  return (
    <>
      {/* Desktop version */}
      <div className="mx-auto w-full 2xl:h-[600px] md:h-[600px] xl:px-0 md:px-8 lg:!px-7 relative square_grid_bg md:pb-0 pb-[0px]">
        <div className="lg:container mx-auto 2xl:px-5 xl:px-2 lg:p-0 text-[#030F1C] z-50 relative">
          <div className="flex justify-between items-center relative md:top-14">
            <div className="md:relative md:w-[54%] mt-28">
              <h1 className="md:text-[40px] tracking-[-1.6px] ml-[36px] 2xl:text-[46px] font-bold md:leading-[42px] 2xl:leading-[52px] bg-gradient-to-r from-[#082647]  to-[#3174d6] bg-clip-text text-transparent">
                Inspiring & Enabling Talent
                <span className="md:text-[36px]  tracking-[-1.44px] 2xl:text-[36px] font-medium md:leading-[42px] 2xl:leading-[52px] text-black block">
                  to Achieve Their Highest <br />
                  Potential
                </span>
              </h1>

              <div
                className="grp_btn !w-fit flex items-center cursor-pointer mt-10"
                onClick={() => scrollToSection("problem_statement")}
              >
                <Image
                  priority
                  src="/arrow2.png"
                  alt="arrow image"
                  className="new_arrow md:w-[40px] 2xl:w-[45px] ml-[36px] "
                  width={45}
                  height={45}
                />
                <p className="new__discover_btn !w-fit font-medium inline-block md:px-[30px] md:text-[14px] 2xl:text-base">
                  Learn More
                </p>
              </div>
            </div>
          </div>
          <div className="lg_desktop">
            <Image
              src="/about-us/bg-des.png"
              alt="Special Offer"
              className="absolute top-0 bottom-0 right-0 z-20 md:w-[669px] h-[507px]"
              width={955}
              height={911}
              priority
            />
          </div>
        </div>
        <div className="md_desktop">
          <Image
            src="/about-us/bg-des.png"
            alt="Special Offer"
            className="absolute top-12 bottom-12 right-12 md:block hidden md:w-[669px] h-[507px] z-20"
            width={669}
            height={507}
            priority
          />
        </div>
      </div>

      <div id="problem_statement" className="w-full"></div>
    </>
  );
};

export default AboutBannerDesktop;
